"use strict";

document.addEventListener("DOMContentLoaded", function() {

    const quickLinksExists = !!document.querySelector('div.quick-links');

    if (quickLinksExists) {

        var links = "";    
        document.querySelectorAll("h2").forEach(function(h2, index) {
            if (h2.dataset.noToc)
                return;
            h2.setAttribute("id", "h2-" + index);
            links += String.format("<a href=#h2-%d aria-label='Skip to %s'>%s</a>", index, h2.textContent, h2.textContent);
       });
       
       document.querySelector("div.quick-links").innerHTML = links;
    
    }

    
}); 